module.exports = new __parcel__URL__("Brainstorming.94b58c6a.svg").toString();